<template>
  <div class="navbar">
    <div class="right-menu">
      <div class="logo" :style="{backgroundImage: `url(${logoImg})`}"></div>
      <div class="avatar-container right-menu-item hover-effect">
        <a v-if="env !== 'offline'" href="/static/course.mp4" target="__blank" class="link-course">验收平台使用说明</a>
        <Progress></Progress>
        <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
          <div class="avatar-wrapper">
            <img class="head" :src="userInfo.headimg"/>
            <div class="username">
              <p class="usernick">{{userInfo.nickname}}({{userInfo.uid}})</p>
            </div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- <router-link to="/">
                <el-dropdown-item>
                {{ $t('navbar.dashboard') }}
                </el-dropdown-item>
            </router-link>
            <a target="_blank" href="https://github.com/PanJiaChen/vue-element-admin/">
                <el-dropdown-item>
                {{ $t('navbar.github') }}
                </el-dropdown-item>
            </a>-->
            <el-dropdown-item>
              <span style="display:block;" @click="logout">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import Progress from "./Progress";
import { longmao } from '@/utils/sso'

export default {
  components: {
    Progress
  },
  data() {
    return {
      // eslint-disable-next-line no-undef
      logoImg: process.env.NODE_IMG_LOGO,
      // eslint-disable-next-line no-undef
      env: process.env.NODE_ENV
    }
  },
  computed: {
    userInfo: function(){
      return this.$store.getters['userInfo']
    }
  },
  methods: {
    targetLogo() {
      this.$router.push({ path: "/" });
    },
    logout() {
      if(window.confirm("确定退出登录吗?")){
        longmao.sso.logout().then(()=>{
          window.location = '/';
        }).catch((err)=>{
          this.$message({
            message: err.message,
            duration: 1500,
            type: 'error'
          })
        })
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  overflow: hidden;
  background: rgba(0, 61, 132, 1);
  box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.1);
  z-index: 1002;
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .link-course {
    color: #ffffff;
    font-size: 14px;
    vertical-align: middle;
    line-height: 64px;
    &:hover {
      text-decoration: underline;
    }
  }
  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    height: 100%;
    line-height: 50px;
    .logo {
      float: left;
      width: 199px;
      height: 30px;
      background: url("../../../assets/logo.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin-top: 16px;
      margin-left: 20px;
      cursor: pointer;
    }
    &:focus {
      outline: none;
    }

    .right-menu-item {
      float: right;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      display: flex;
      justify-content: center;
      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;
      .avatar-wrapper {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        .head {
          width: 30px;
          height: 30px;
          border-radius: 20px;
          margin-right: 15px;
        }
        .username {
          font-size: 14px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          .usernick,.useruid{
            margin: 0;
            line-height:24px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue